// src/components/index.js
// Используем require.context для автоматического импорта всех файлов с расширением .jsx
import ProviderUtils from "../utils/provider.utils";

const context = require.context("./", true, /\.(jsx|tsx)$/);
const resolvedComponents = ProviderUtils.resolveComponents(context);

export default resolvedComponents;
